import { render, staticRenderFns } from "./DocumentViewModal.vue?vue&type=template&id=28288574&"
import script from "./DocumentViewModal.vue?vue&type=script&lang=js&"
export * from "./DocumentViewModal.vue?vue&type=script&lang=js&"
import style0 from "./DocumentViewModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports